module.exports = __webpack_public_path__ + "static/media/eleven.d6c7f609.jpg";